import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { securityContext } from '../../utils/Security';
import { Router } from '@angular/router';
@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private sharedConfigSubject = new BehaviorSubject<any>(null);
    private nameUser = new BehaviorSubject<any>("");
    
    private urlLogin(){ 
        return '/login';
    }

    constructor(private router: Router) { }

    setValueUser(newValue: string): void {
        if (sessionStorage.getItem("du") == null) {
            try {
                sessionStorage.setItem("du", newValue);
            } catch (err) {
                sessionStorage.clear();
                this.sharedConfigSubject.next(null);
                this.nameUser.next("");
                const rutaDestino = this.urlLogin();
                const rutaActual = this.router.url;
                if (rutaActual !== rutaDestino) {
                    this.router.navigate([rutaDestino]);
                }
            }
        }
    }

    setValueConfig(newValue: string): void {
        if (this.sharedConfigSubject.getValue() == null) {
            try {
                sessionStorage.setItem("dc", newValue);
                const valueJson = JSON.parse(securityContext().decrypt(newValue));
                this.sharedConfigSubject.next(valueJson);
            } catch (err) {
                sessionStorage.clear();
                this.sharedConfigSubject.next(null);
                this.nameUser.next("");
                const rutaDestino = this.urlLogin();
                const rutaActual = this.router.url;
                if (rutaActual !== rutaDestino) {
                    this.router.navigate([rutaDestino]);
                }
            }
        }
    }

    getValueUser(): any {
        try {
            const value = sessionStorage.getItem("du");
            if (value) {
                const valueJSON = JSON.parse(securityContext().decrypt(value));
                return valueJSON;
            } else {
                sessionStorage.clear();
                this.sharedConfigSubject.next(null);
                this.nameUser.next("");
                const rutaDestino = this.urlLogin();
                const rutaActual = this.router.url;
                if (rutaActual !== rutaDestino) {
                    this.router.navigate([rutaDestino]);
                }
            }
        } catch (err) {
            sessionStorage.clear();
            this.sharedConfigSubject.next(null);
            this.nameUser.next("");
            const rutaDestino = this.urlLogin();
            const rutaActual = this.router.url;
            if (rutaActual !== rutaDestino) {
                this.router.navigate([rutaDestino]);
            }
        }
    }

    getValueConfig(): any {
        if (this.sharedConfigSubject.getValue() == null) {
            try {
                const value = sessionStorage.getItem("dc");
                if (value) {
                    const valueJSON = JSON.parse(securityContext().decrypt(value));
                    this.sharedConfigSubject.next(valueJSON);
                    return valueJSON;
                } else {
                    sessionStorage.clear();
                    this.sharedConfigSubject.next(null);
                    this.nameUser.next("");
                    const rutaDestino = this.urlLogin();
                    const rutaActual = this.router.url;
                    if (rutaActual !== rutaDestino) {
                        this.router.navigate([rutaDestino]);
                    }
                }
            } catch (err) {
                sessionStorage.clear();
                this.sharedConfigSubject.next(null);
                this.nameUser.next("");
                const rutaDestino = this.urlLogin();
                const rutaActual = this.router.url;
                if (rutaActual !== rutaDestino) {
                    this.router.navigate([rutaDestino]);
                }
            }
            return null;
        } else {
            return JSON.parse(JSON.stringify(this.sharedConfigSubject.getValue()));
        }
    }

    isAuthenticated() {
        try {
            let du: any = sessionStorage.getItem("du");
            du = JSON.parse(securityContext().decrypt(du));
            this.nameUser.next(du.nombreCompleto);
        } catch (err) {
            sessionStorage.clear();
            this.sharedConfigSubject.next(null);
            this.nameUser.next("");
            return false;
        }
        return true;
    }

    clearAll() {
        this.sharedConfigSubject.next(null);
        this.nameUser.next("");
    }

    getNameUser(){
        return this.nameUser.getValue();
    }
}